import styled from 'styled-components';

export const StyledHeaderTitle = styled.div<{
  position: 'left' | 'center' | 'right';
}>`
  
  text-align: "left"
  justify-content: ${({ position }): string => {
    const flexPositionMap = {
      left: 'flex-start',
      center: 'center',
      right: 'flex-end'
    };
    return flexPositionMap[position];
  }};
`;
